import { FC } from "react";
import { CashbackInput } from "../CashbackInput/cashbackInput";
import { CashbackEarnPreview } from "../CashbackEarnPreview/cashbackEarnPreview";
import { useFoodCashbackRedeem } from "../../hooks/useFoodCashbackRedeem";
import { useFoodCashbackEarn } from "../../hooks/useFoodCashbackEarn";
import { floatToPriceWithoutSpace } from "../../functions/price_functions";

type Props = {
  /** Se false, não chama APIs nem renderiza (ex.: loja TOTVS 105 able) */
  enabled?: boolean;
  /** Bloqueia resgate quando há cupom ativo */
  hasCoupon?: boolean;
  /** Exibe linha de valor aplicado no resumo */
  showAppliedInSummary?: boolean;
};

/**
 * Bloco de cashback do Food: prévia de ganho + input de resgate.
 * Só renderiza/chama API quando feature + cliente permitem.
 */
const FoodCashbackSection: FC<Props> = ({
  enabled = true,
  hasCoupon = false,
  showAppliedInSummary = true,
}) => {
  const {
    shouldShowCashback,
    availableBalance,
    redeemValue,
    setRedeemValue,
    hasCashback,
    appliedAmount,
    loading: loadingCashback,
    applyCashbackRedeem,
    clearCashbackRedeem,
  } = useFoodCashbackRedeem({ enabled });

  const {
    shouldShowEarn,
    earnAmount,
    loading: loadingEarn,
  } = useFoodCashbackEarn({ enabled });

  if (!enabled) return null;
  if (
    !shouldShowEarn &&
    !shouldShowCashback &&
    !(hasCashback && appliedAmount > 0)
  ) {
    return null;
  }

  return (
    <div style={{ width: "100%", marginTop: "1em", marginBottom: "0.5em" }}>
      {shouldShowEarn && (
        <CashbackEarnPreview
          amount={earnAmount}
          loading={loadingEarn}
          backgroundColor="#fff"
        />
      )}

      {shouldShowCashback && !hasCoupon && (
        <div style={{ marginTop: shouldShowEarn ? "0.75em" : 0 }}>
          <CashbackInput
            redeemValue={redeemValue}
            setRedeemValue={setRedeemValue}
            availableBalance={availableBalance}
            hasCashback={hasCashback}
            appliedAmount={appliedAmount}
            loading={loadingCashback}
            disabled={hasCoupon}
            onApply={applyCashbackRedeem}
            onRemove={() => clearCashbackRedeem()}
            backgroundColor="#fff"
          />
        </div>
      )}

      {/* {showAppliedInSummary && hasCashback && appliedAmount > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "0.75em",
            fontFamily: "Open Sans, sans-serif",
            fontSize: 13,
            color: "#636363",
          }}
        >
          <span>Cashback</span>
          <span>-{floatToPriceWithoutSpace(appliedAmount)}</span>
        </div>
      )} */}
    </div>
  );
};

export { FoodCashbackSection };
